import { render, staticRenderFns } from "./ProductStorage.vue?vue&type=template&id=8cb26524&scoped=true&"
import script from "./ProductStorage.vue?vue&type=script&lang=js&"
export * from "./ProductStorage.vue?vue&type=script&lang=js&"
import style0 from "./ProductStorage.vue?vue&type=style&index=0&id=8cb26524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb26524",
  null
  
)

export default component.exports